// const sets = require("../test/sets.json");
export const YEAR = "year";
export const BRAND = "brand";
export const SETNAME = "set_name";
export const SUBSET = "subset";
export const CARDNAME = "card_name";
export const CARDNUMBER = "card_number";
export const SERIALNUMBER = "serial_number";
export const SubsetKeys = [YEAR, BRAND, SETNAME, SUBSET];
export const CardKeys = [CARDNAME, CARDNUMBER, SERIALNUMBER];
export const CARDNUMBER_FIRST_TYPES = ["Pokemon"];
export const CardKeys_Alt = [CARDNUMBER, CARDNAME, SERIALNUMBER];
export const CardLabels = {
  [CARDNUMBER]: "Card Number",
  [CARDNAME]: "Character/Player Name",
  [SERIALNUMBER]: "Serial Number",
};

export default function get_distinct(key, sets, dependents = null) {
  if (dependents) {
    const iterator = Object.keys(dependents);
    for (const k of iterator) {
      if (dependents[k])
        sets = sets.filter((c) => c[k] && c[k] === dependents[k]);
    }
  }
  let unique = [...new Set(sets.map((item) => item[key]))];
  if (key === CARDNUMBER) {
    return unique.sort(function (a, b) {
      return a - b;
    });
  }
  return unique.sort();
}

export function get_filtered_sets(sets, dependents = null) {
  if (dependents) {
    const iterator = Object.keys(dependents);
    for (const k of iterator) {
      sets = sets.filter((c) => c[k] && c[k] === dependents[k]);
    }
  }
  return sets;
}

export function get_set(sets, dependents = null) {
  if (dependents) {
    const iterator = Object.keys(dependents);
    for (const k of iterator) {
      sets = sets.filter((c) => c[k] && c[k] === dependents[k]);
    }
  }
  return sets;
}

export function getSerialNumber(selectedCard, cards) {
  let card = {...selectedCard};
  delete card[SERIALNUMBER];
  const iterator = Object.keys(card);
  for (const k of iterator) {
    cards = cards.filter((c) => c[k] && c[k] === card[k]);
  }
  if (cards) {
    if (Array.isArray(cards) && cards[0]) return cards[0][SERIALNUMBER];
    return cards[SERIALNUMBER];
  }
  return "";
}
